import { useCallback, useEffect, useState } from "react";
import { Document, Page } from "react-pdf";

// Custom components
import AssignmentStatusHistory from "@/PayPlans/components/Tables/AssignmentStatusHistory/AssignmentStatusHistory";

// MUI
import { Box, Skeleton } from "@mui/material";

function CustomLoading() {
	return (
		<Box display="flex" justifyContent="center" alignItems="center" height="100%">
			<Skeleton variant="rectangular" width="80%" height={600} />
		</Box>
	);
}

type ContentDialogProps = {
	content: string;
	rowData?: unknown;
	file?: File;
};

type RowData = {
	acknowledgementDate: string;
	row: {
		id: string;
		acknowledgementStatus: {
			status: string;
			statusDate: string;
		}[];
	};
};
export default function ContentDialog({ content, rowData, file }: ContentDialogProps) {
	const [numPages, setNumPages] = useState(0);

	function onDocumentLoadSuccess(docProps: { numPages: number }) {
		setNumPages(docProps.numPages);
	}

	const renderDocument = useCallback(
		(localFile: File) => {
			if (!localFile) {
				return null;
			}

			return (
				<Document file={localFile} onLoadSuccess={onDocumentLoadSuccess} loading={<CustomLoading />}>
					{Array.from(Array(numPages), (_el, index) => (
						<Page
							key={`page_${index + 1}`}
							pageNumber={index + 1}
							scale={1.5}
							loading=""
							renderTextLayer={true}
							renderAnnotationLayer={false}
						/>
					))}
				</Document>
			);
		},
		[numPages]
	);

	useEffect(() => {
		return () => {
			setNumPages(0);
		};
	}, []);

	switch (content) {
		case "content1":
			return renderDocument(file as File);
		case "content2":
			return renderDocument(file as File);
		case "content3":
			return <AssignmentStatusHistory data={(rowData as RowData) || []} />;
		case "content4":
			return renderDocument(file as File);
		default:
			return null;
	}
}
